import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { BasePageComponent } from '../../../core/classes/base-page';
import { HelpersService } from '../../../core/services/helpers.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingService } from '../../../core/services/loading.service';
import { AuthService } from '../../../core/services/auth.service';
import { FileService } from '../../../core/api/file.service';
import { CashAdvanceService } from '../../../core/api/cash-advance.service';
import { debounceTime } from 'rxjs';
import { CheckSelect } from '../../../core/classes/check-select';
import { FilePreviewComponent } from '../../../components/file-preview/file-preview.component';

@Component({
  selector: 'app-cash-advance-claimer',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule,
    MatDividerModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
  ],
  templateUrl: './cash-advance-claimer.component.html',
  styleUrl: './cash-advance-claimer.component.scss',
})
export class CashAdvanceClaimerComponent
  extends BasePageComponent<any>
  implements OnInit
{
  searchFormControl = new FormControl();
  counter = {
    draftCount: 0,
    completedCount: 0,
    sentCount: 0,
    rejectedCount: 0,
    disbursedCount: 0,
    all: 0,
  };
  currentFilter: any;

  constructor(
    public override helpers: HelpersService,
    public override router: Router,
    public override activatedRoute: ActivatedRoute,
    public override dialog: MatDialog,
    public override loading: LoadingService,
    public override service: CashAdvanceService,
    public override authService: AuthService,
    private fileService: FileService
  ) {
    super(
      helpers,
      router,
      activatedRoute,
      dialog,
      loading,
      service,
      authService
    );
    this.displayedColumns = [
      'no',
      'refId',
      'file',
      'title',
      'expense_category',
      'status',
      'date',
      'amount',
      'action',
    ];
    this.sortActive = 'updated_at';
    this.sortDirection = 'desc';
    this.subject = 'refId';
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.searchFormControl.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val: any) => {
        this.q.search = val;
        this.getData();
      });
  }

  override afterInit(): void {
    this.getData();
  }

  override getData(): void {
    this.loading.startLoading();
    this.service
      .getAllClaimer(this.q)
      .then((data) => {
        const draft = data.draftCount ?? 0;
        const sent = data.sentCount ?? 0;
        const rejected = data.rejectedCount ?? 0;
        const disbursed = data.completedCount ?? 0;
        const completed = data.approvedCount ?? 0;
        const all = data.allCount ?? 0;
        this.counter.all = all;
        this.counter.completedCount = completed;
        this.counter.disbursedCount = disbursed;
        this.counter.draftCount = draft;
        this.counter.rejectedCount = rejected;
        this.counter.sentCount = sent;

        this.assignData(data.reports);
        this.afterGetData();
        this.loading.endLoading();
      })
      .catch((err) => {
        this.helpers.sbError(err);
        this.loading.endLoading();
      });
  }

  addClaim() {
    this.router.navigate(['/dashboard/cash-advance-claimer/action'], {
      queryParams: {
        m: 'add',
      },
    });
  }

  editClaim(id: any) {
    this.router.navigate(['/dashboard/cash-advance-claimer/action'], {
      queryParams: {
        m: 'edit',
        id,
      },
    });
  }

  resubmit(id: any) {
    this.router.navigate(['/dashboard/cash-advance-claimer/action'], {
      queryParams: {
        m: 'edit',
        id,
        type: 'resubmit',
      },
    });
  }

  resubmitSettlement(id: any) {
    this.router.navigate(['/dashboard/cash-advance-approval/action'], {
      queryParams: {
        m: 'detail',
        id,
        type: 'resubmit',
      },
    });
  }

  detailClaim(id: any) {
    this.router.navigate(['/dashboard/cash-advance-approval/action'], {
      queryParams: {
        m: 'detail',
        id,
      },
    });
  }

  download(item: any) {
    const targetFile = this.helpers.resolveTargetFile(item);
    if (targetFile?.id) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: targetFile,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }

  getFileItems(element: any): any[] {
    return this.helpers.normalizeFileItems(element);
  }

  changeFilter(filter: any): void {
    if (this.currentFilter === filter || filter == null) {
      this.currentFilter = 'all';
    } else {
      this.currentFilter = filter;
    }
    this.q.status = this.currentFilter;
    this.getData();
  }
}
